import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LazyService } from 'src/app/lazy.service';

import { PageService } from '../../services/page.service';

@Component({
  selector: 'app-highlight-detail',
  templateUrl: './highlight-detail.component.html',
  styleUrls: ['./highlight-detail.component.scss']
})
export class HighlightDetailComponent implements OnInit, OnDestroy {
  @ViewChild('dynamicComponents', { read: ViewContainerRef })
  container: ViewContainerRef;
  private blockElementRef;
  private expanderBodyEl;
  @Input() set page(uri: string) {
    this.pageInit(uri);
  }
  @Input() variant;
  @Output() hideDetail: EventEmitter<any> = new EventEmitter();
  public block: any = {};
  public shareMetadata: { title?: string; image?: string } = {};
  constructor(
    private translate: TranslateService,
    private pageService: PageService,
    private elRef: ElementRef,
    private lazy: LazyService
  ) {}

  ngOnInit() {}

  pageInit(page) {
    this.pageService
      .getPage(page.replace('/', ''), this.translate.currentLang)
      .subscribe(
        (data: any) => {
          this.block = data;
          this.lazy.loadAndRenderComponents(data, this.container);
          this.reCalculateBlockMargin();
        },
        e => {
          if (e.status > 299) {
            console.log(e.status);
            this.close();
          }
        }
      );
    if (this.blockElementRef) {
      this.blockElementRef.style.marginBottom = '0px';
    }
    try {
      const expanderEl = this.elRef.nativeElement.querySelector(
        '.expander-wrapper'
      );
      this.expanderBodyEl = this.elRef.nativeElement.querySelector(
        '.expander-body-wrapper'
      );
      const upArrowEl = this.elRef.nativeElement.querySelector(
        '.arrow-pointer'
      );
      this.blockElementRef = window.document
        .querySelector(`[id='${page}']`)
        .closest('.block');
      expanderEl.style.marginTop = `${this.blockElementRef.offsetTop +
        this.blockElementRef.offsetHeight}px`;
      upArrowEl.style.left = `${this.blockElementRef.offsetLeft +
        this.blockElementRef.offsetWidth / 2}px`;
      this.blockElementRef.style.marginBottom = `${this.expanderBodyEl
        .offsetHeight + 10}px`;
    } catch (e) {
      console.error(e);
      this.close();
    }
  }

  private reCalculateBlockMargin() {
    setTimeout(() => {
      this.blockElementRef.style.marginBottom = `${this.expanderBodyEl
        .offsetHeight + 10}px`;
      const expanderEl = this.elRef.nativeElement.querySelector(
        '.expander-wrapper'
      );
      this.blockElementRef.scrollIntoView({ behavior: 'smooth' });
      expanderEl.style.marginTop = `${this.blockElementRef.offsetTop +
        this.blockElementRef.offsetHeight}px`;
    }, 500);
  }
  close() {
    this.hideDetail.emit(false);
  }
  ngOnDestroy() {
    this.blockElementRef.style.marginBottom = '0px';
    window.location.hash = '';
  }
}
